import axios from 'axios'
import router from '@/router'
import store from '@/store'


//const serverURL = 'http://localhost:3000'
// const serverURL = 'https://s2.click2meet.de:3000'
// const serverURL = 'https://api.c-learning.de'
// const serverURL = 'https://api.c-learning.cn'
const serverURL = process.env.VUE_APP_ROOT_API || 'https://api.c-learning.de'


const config = {
    baseURL: `${serverURL}/v1`,
    withCredentials: false, // This is the default
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
    timeout: 25000
}
let originalUrl = null

const apiClient = axios.create(config)

function authHeaderInterceptor(config) {
    const token = store.state?.user?.tokens?.access?.token
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}

function accessTokenRefreshInterceptor(error) {
    const status = error.response ? error.response.status : null;
    const config = error.config ? error.config : null;

    if (config.url === '/auth/verify-email'){
        return;
    }

    if(config.url !== '/auth/refresh-tokens') {
        originalUrl = config.url
    }
    if (status !== 401) {
        return Promise.reject(error);
    }
    if (config.url === '/auth/login'
        || config.url.startsWith('/auth/reset-password')
        || config.url === '/sso/authTokens') {
        return Promise.reject(error);
    }

    // TODO check if user is disabled
    if (config.url === '/auth/refresh-tokens') {
        if (originalUrl && !(originalUrl.includes('/statistics/logs') || originalUrl.includes('/studyProgress'))) {
            store.commit('logout')
            router.push({ name: 'Login'});
        }
        return Promise.reject(error);
    }

    const refreshToken = store.getters.refreshToken ? store.getters.refreshToken : 'invalid_token'
    if(!config._retry) {
        return apiClient.post('/auth/refresh-tokens', { refreshToken }).then(response => {
            const tokens = response?.data
            store.commit('updateTokens', tokens)
            config.headers['Authorization'] = `Bearer ${tokens?.access?.token}`;
                config._retry = true
                return apiClient.request(config)
        })
    }
}

apiClient.interceptors.request.use((config) => {
    if (!config.skipOverlay) {
        store.commit('setLoading', true)
    }
    return authHeaderInterceptor(config)
})
apiClient.interceptors.response.use(response => {
    store.commit('setLoading', false)
    return response
}, error => {
    store.commit('setLoading', false)
    return accessTokenRefreshInterceptor(error)
})
export default {
    login(email, password) {
        return apiClient.post('/auth/login', { email, password }).then(response => {
            return response.data
        })
    },
    otpLogin(token){
        return apiClient.get("auth/otp-login?token="+encodeURIComponent(token)).then(result => {
            return result.data;
        }).catch(error => {
            console.error("otp login failed:", error);
            return null;
        });
    },
    gatewayLogin(email, password){
        return apiClient.post('/auth/gateway-login', { email, password }).then(response => {
            return response.data
        });
    },
    getOneTimePassword(){
        return apiClient.get("auth/get-otp").then(result => {
            return result.data;
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    logout(refreshToken) {
        return apiClient.post('/auth/logout', { refreshToken })
    },
    refreshToken(refreshToken) {
        return apiClient.post('/auth/refresh-tokens', { refreshToken }).then(response => {
            return response?.data
        })
    },
    verifyEmail(token){
        let data = {};
        data.token = token;
        // eslint-disable-next-line no-unused-vars
        return apiClient.post('/auth/verify-email', {token}).then(response => {

            return true;
        }).catch(error => {
            console.log(error);
            return false;
        });
    },
    forgotPassword(email){
        let data = {};
        data.email = email;
        return apiClient.post('/auth/forgot-password', data)
    },
    resetPassword(token, password){
        let data = {};
        data.password = password;
        return apiClient.post('/auth/reset-password?token='+token, data)
    },

    // eslint-disable-next-line no-unused-vars
    sendStudyProgress(courseId, chapterId = "", lessonId = "", end = false, start = false, lastAccess = false){

        console.log("save study progress? " + store.state.user.saveStats);
        if (store && store.state.user && store.state.user.saveStats === false) return;

        let data = {};

        if(chapterId !== ""){
            data.chapter = chapterId
        }
        if(lessonId !== ""){
            data.lesson = lessonId;
        }
        if(start){
            data.startDate = (new Date()).toISOString();
        }
        if(end){
            data.completionDate = (new Date()).toISOString();
        }
        if(lastAccess){
            data.lastAccessDate = (new Date()).toISOString();
        }
        console.log("send study progress", data);
        return apiClient.post("/courses/"+courseId+"/studyProgress", data).then(result => {
            console.log(result);
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    updateStudyProgress(courseId, chapterId = "", lessonId = "", end = false, start = false, lastAccess = false){

        console.log("update study progress? " + store.state.user.saveStats);
        if (store && store.state.user && store.state.user.saveStats === false) return;

        let data = {};

        let now = (new Date()).toISOString();

        if(chapterId !== ""){
            data.chapter = chapterId
        }
        if(lessonId !== ""){
            data.lesson = lessonId;
        }
        if(start){
            data.startDate = now;
        }
        if(end){
            data.completionDate = now;
        }
        if(lastAccess){
            data.lastAccessDate = now;
        }
        console.log("update study progress", data);
        return apiClient.patch("/courses/"+courseId+"/studyProgress", data).then(result => {
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    getStudyProgress(courseId){
        return apiClient.get("/courses/"+courseId+"/studyProgress").then(result => {
            return result.data;
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    getStudyProgressUser(userId){
        return apiClient.get("/users/"+userId+"/studyProgress").then(result => {
            //console.log(result);
            let sortedResult = result.data.results.sort((a,b) => {
                let dateA = a.completionDate ? new Date(a.completionDate) : new Date(0); // epoch if no date
                let dateB = b.completionDate ? new Date(b.completionDate) : new Date(0); // epoch if no date
                return dateB - dateA;
            });
            return sortedResult;
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    sendEvent(type, value = "", courseId = "", chapterId = "", lessonId = "", licenseId = ""){

        console.log("save stats? " + store.state.user.saveStats);
        if (store && store.state.user && store.state.user.saveStats === false) return;

        let data = {
            "type": type
        };
        if(value !== ""){
            data.value = value;
        }
        if(courseId !== ""){
            data.courseId = courseId;
        }
        if(chapterId !== ""){
            data.chapterId = chapterId
        }
        if(lessonId !== ""){
            data.lessonId = lessonId;
        }
        if(licenseId !== ""){
            data.licenceId = licenseId;
        }

        return apiClient.post("/statistics/logs", data).then(result => {
            //console.log(result);
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },

    sendNotificationMail(subject, body, file = null, to = "lernportal@christiani.de") {

        console.log(file);

        // Erstelle ein neues FormData Objekt
        let formData = new FormData();

        // Füge die benötigten Daten hinzu
        formData.append("to", to);
        formData.append("subject", subject);
        formData.append("body", body);
        if(file)
            formData.append("screenshot", file, file.name);

        // Setze die Anforderung mit den passenden Headern
        const headers = { "Content-Type": "multipart/form-data" };

        // Sende die Anforderung
        return apiClient.post("/users/sendNotificationEmail", formData, { headers: headers })
            .then(result => {
                console.log(result);
                return result.data;
            })
            .catch(error => {
                console.log(error);
                return null;
            });
    },

    /**
     * =========================================
     * Notification Endpoints (Holger / Staging)
     * Base: /v1
     *
     * All endpoints require a valid Bearer token.
     *
     * Docs:
     * - POST   /users/:userId/notifications
     * - GET    /users/me/notifications
     * - PATCH  /users/me/notifications
     * - POST   /users/me/notifications/:notificationId/mark-read
     * =========================================
     */

    /**
     * Send a notification to another user.
     *
     * POST /users/:userId/notifications
     *
     * @param {string} userId - Recipient user id
     * @param {string} message - Notification message (1-5000 chars)
     * @returns {Promise<Object>} created notification object
     */
    sendNotificationToUser(userId, message) {
        // backend rejects sending notifications to yourself
        return apiClient.post(`/users/${userId}/notifications`, { message }).then(result => {
            return result.data
        }).catch(error => {
            console.log(error)
            return Promise.reject(error)
        })
    },

    /**
     * Get notifications for the authenticated user.
     *
     * GET /users/me/notifications
     *
     * Optional query params:
     * - isRead   (boolean)
     * - sortBy   (string)   default: createdAt:desc
     * - limit    (number)   default: 10
     * - page     (number)   default: 1
     * - populate (string)   e.g. "sender"
     *
     * @param {Object} params
     * @returns {Promise<Object>} paginated result { results, page, limit, totalPages, totalResults }
     */
    getMyNotifications(params = {}) {
        // axios serializes params into query string
        console.log("getMyNotifications:");
        console.log(params);
        return apiClient.get('/users/me/notifications', { params }).then(result => {
            return result.data
        }).catch(error => {
            console.log(error)
            return Promise.reject(error)
        })
    },

    /**
     * Mark ALL notifications of the authenticated user as read.
     *
     * PATCH /users/me/notifications
     * Response: 204 No Content
     *
     * @returns {Promise<boolean>} true on success
     */
    markAllNotificationsAsRead() {
        return apiClient.patch('/users/me/notifications').then(() => {
            return true
        }).catch(error => {
            console.log(error)
            return Promise.reject(error)
        })
    },

    /**
     * Mark ONE notification as read.
     *
     * POST /users/me/notifications/:notificationId/mark-read
     *
     * @param {string} notificationId
     * @returns {Promise<Object>} updated notification object
     */
    markNotificationAsRead(notificationId) {
        return apiClient.post(`/users/me/notifications/${notificationId}/mark-read`).then(result => {
            return result.data
        }).catch(error => {
            console.log(error)
            return Promise.reject(error)
        })
    },



    getUserEvents(userId, type = ""){
        let addParams = "";
        if(type != ""){
            addParams += "&type="+type;
        }
        return apiClient.get(`/statistics/logs/?userId=${userId}&sortBy=date:desc`+addParams).then(result => {
            //console.log(result);
            return result.data;
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    getUserLicenseManagers(){
        console.log("get usr license managers");
        return apiClient.get(`/users/me/licence-managers`).then(result => {
            console.log(result);
            return result.data
        })
    },
    getUserLicenseContacts(){
        console.log("get usr license managers");
        return apiClient.get(`/users/me/licence-contacts`).then(result => {
            console.log(result);
            return result.data
        })
    },
    getUserGroups(userId) {
        console.log("get groups for user "+userId);
        return apiClient.get(`/users/${userId}/groups`).then(result => {
            console.log(result);
            return result.data.results
        })
    },
    getUserGroupMemberships(userId) {
        console.log("get groups for user "+userId);
        return apiClient.get(`/users/${userId}/groups/memberships`).then(result => {
            console.log(result);
            return result.data.results
        })
    },
    getManagedUsers(userId) {
        return apiClient.get(`/users/${userId}/managedUsers`).then(result => {
            return result.data;
        });
    },
    getTeamMembers(userId) {
        return apiClient.get(`/users/${userId}/teamMembers`).then(result => {
            //console.log("Employees:", result.data)
            return result.data.results
        });
    },
    registerUser(user){
        return apiClient.post("auth/register", user).then(result => {
            return result.data
        })
    },
    getUsers() {
        return apiClient.get("/users?limit=10000").then(result => {
            return result.data.results
        })
    },
    getUser(userId) {
        return apiClient.get(`/users/${userId}`, { skipOverlay: true }).then(result => {
            console.log("User:", result.data)
            return result.data
        })
    },
    getBadge(badgeId) {
        return apiClient.get( `/badges/${badgeId}`).then(result => {
            console.log("Badges:", result.data)
            return result.data
        })
    },
    getBadges() {
        return apiClient.get( "/badges").then(result => {
            console.log("Badges:", result.data)
            return result.data.results
        })
    },
    isEmailTaken(email) {
        return apiClient.get(`/users?email=${email}`).then((result) => {
            return result.data.totalResults > 0
        })
    },
    isLoginTaken(loginName) {
        return apiClient.get(`/users?loginName=${loginName}`).then((result) => {
            return result.data.totalResults > 0
        })
    },
    isGroupNameTaken(groupName) {
        return apiClient.get(`/groups?name=${groupName}`).then((result) => {
            return result.data.totalResults > 0
        })
    },
    saveUser(user) {
        return apiClient.post("/users", user).then(result => {
            return result.data
        })
    },
    updateUser(user) {
        const userId = user.id
        const _user = {...user}
        delete _user.id
        delete _user.assignments

        return apiClient.patch(`/users/${userId}`, _user).then(result => {
            return result.data
        })
    },
    deleteUser(user) {
        return apiClient.delete(`/users/${user.id}`).then(result => {
            return result.data
        })
    },
    getGroup(group) {
        return apiClient.get(`/groups/${group.id}`).then(result => {
            return result.data.results
        })
    },
    getGroups(instance = undefined) {
        return apiClient.get( "/groups?" + (instance ?  "instance=" +  instance : "")).then(result => {
            return result.data.results
        }).catch(error => {
            return Promise.reject(error)
        })
    },
    saveGroup(group) {
        if(!group.id) {
            return apiClient.post("/groups", group).then(result => {
                return result.data
            })
        } else {
            const groupId = group.id
            delete group.id
            return apiClient.patch(`/groups/${groupId}`, group).then(result => {
                return result.data
            })
        }
    },
    deleteGroup(group) {
        return apiClient.delete(`/groups/${group.id}`)
    },
    getMembers(groupId) {
        return apiClient.get(`/groups/${groupId}/members`).then(result => {
            return result.data
        })
    },
    getInstances() {
        return apiClient.get('/instances').then(result => {
            return result.data
        })
    },
    getAuthCode(clientId, redirectUri, scope) {
        return apiClient.post(`/sso/authCode`, {clientId, redirectUri, scope}).then(result => {
            return result.data
        })
    },
    getAuthToken(code, redirectUri, idp = "") {
        let addIpd = "";
        if(idp == "edcast"){
            addIpd = "?idp=edcast"
        }
        return apiClient.post("/sso/authTokens"+addIpd, {"code": code, "redirect_uri": redirectUri, "grant_type": "authorization_code"}).then(result => {
            console.log(result);
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    getTags() {
        return apiClient.get( "/tags").then(result => result.data.results).then(tags => {
            return tags
        })
    },
    getUserLicences(userId, checkFrontendManagable) {
        return apiClient.get( 'users/'+userId+'/licences').then(result => {
            console.log("Licences:", result.data)
            let licenses = [];
            if(checkFrontendManagable){
                for(let i=0; i<result.data.results.length; i++){
                    if(result.data.results[i].isFrontendManageable === true){
                        licenses.push(result.data.results[i]);
                    }
                }
            }else{
                licenses = result.data.results;
            }
            return licenses
        }).catch(error => {
            console.log("Error getting licences", error)
            return Promise.reject(error)
        })
    },
    getAssignments(licenceId) {
        return apiClient.get(`/licences/${licenceId}/assignments`).then(result => result.data)
    },
    updateAssignments(licenceId, assignments) {
        console.log("update LicenceAssignment", licenceId)
        return apiClient.put(`/licences/${licenceId}/assignments`, {assignments} ).then(result => {
            console.log(result)
        })
    },
    addTeamMember(userId, member) {
        return apiClient.post(`/users/${userId}/teamMembers`, member).then(result => {
            console.log("Employees:", result.data)
        })
    },
    getCourses(instance = undefined) {
        return apiClient.get( "/courses?" + (instance ?  "instance=" +  instance : ""), { skipOverlay: true }).then(result => {
            return result.data.results
        })
    },
    getUserCourses(userId) {
        return apiClient.get( `/users/${userId}/courses`, { skipOverlay: true }).then(result => {
            //console.log(result.data);
            return result.data
        })
    },
    getCoursesInfo() {
        return apiClient.get( "/public/courses/info").then(result => {
            return result.data.results
        })
    },
    getDemoCourses() {
        return apiClient.get( "/public/courses/demo").then(result => {
            //console.log(result.data);
            return result.data
        })
    },
    deleteCourse(course) {
        return apiClient.delete(`/courses/${course.id}`)
    },
    saveCourse(course) {
        if(!course.id) {
            return apiClient.post("/courses", course).then(result => {
                return result.data
            })
        } else {
            const _course = { ...course }
            const courseId = course.id
            delete _course.id
            delete _course.createdAt
            delete _course.updatedAt
            return apiClient.patch(`/courses/${courseId}`, _course).then(result => {
                return result.data
            })
        }
    },
    getCourse(course_id, deep = false) {
        console.log("get course");
        return apiClient.get(`/courses/${course_id}?deep=${deep ? "true": "false"}`, { skipOverlay: true }).then(result => {
            console.log(result.data);
            return result.data
        }).catch(error => {
            if (error.response) {
                console.log("Statuscode: " + error.response.status)
                return error.response.status;
            } else {
                // Etwas passierte bei der Einstellung des Request, was einen Fehler auslöste
                console.log("Error", error.message);
            }
            return null;
        });
    },
    getCourseUsers(course_id){
        return apiClient.get(`/courses/${course_id}/assignedUsers`, { skipOverlay: true }).then(result => {
            //console.log(result.data);
            return result.data.results;
        })
    },
    getFileToken(file_id){
        console.log("get file token for "+file_id);
        return apiClient.get(`/files/getFileAccessCode/${file_id}`).then(result => {
            console.log("file token result");
            console.log(result.data);
            return result.data.code;
        }).catch(error => {
            console.log(error);
            return false;
        });
    },
    isCourseTitleTaken(courseTitle) {
        return apiClient.get(`/courses?name=${courseTitle}`).then((result) => {
            return result.data.totalResults > 0
        })
    },

    uploadCoureData(file, onUploadProgress, description = "") {
        let formData = new FormData();

        formData.append("courseData", file);
        formData.append("description", description);

        return apiClient.post("/upload/courseData", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress,
            timeout: 0
        });
    },
    upload(file, onUploadProgress, extractZip, description = "") {
        let formData = new FormData();

        formData.append("file", file);
        formData.append("description", description)
        formData.append("unzipContent", extractZip.toString())

        console.log("formdata");
        console.log(formData);

        return apiClient.post("/content/", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress,
            timeout: 0
        }).catch(error => {
            console.log(error);
            return false;
        });
    },

    /*
     Edited Files
     */
    uploadPDF(file, onUploadProgress, id = "") {
        let formData = new FormData();
        console.log("upload pdf: "+id);
        formData.append("pdf", file);

        let addId = "";
        if(id !== ""){
            addId = id;
        }

        return apiClient.post("/users/pdf/upload/"+addId, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress,
            timeout: 0
        }).catch(error => {
            console.log(error);
            return false;
        });
    },
    getSavedFiles(user, owner) {
        let params = {};
        if (user && user.trim() !== "") {
            params.user = user;
        }
        if (owner && owner.trim() !== "") {
            params.owner = owner;
        }
        params = {};

        return apiClient.get('/savedFiles?limit=-1', { params: params })
            .then(response => {
                console.log(response.data);
                return response.data.results ? response.data.results : [];
            })
            .catch(error => {
                console.log(error);
                return [];
            });
    },
    saveFile(dataObject) {
        return apiClient.post('/savedFiles', dataObject)
            .then(response => {
                console.log(response.data);
                return response.data;
            })
            .catch(error => {
                console.log(error);
                return null;
            });
    },
    updateFile(dataObject) {
        let id = dataObject.id;
        delete dataObject.id;
        return apiClient.patch(`/savedFiles/${id}`, dataObject)
            .then(response => {
                console.log(response.data);
                return response.data;
            })
            .catch(error => {
                console.log("Error updatiung file: "+error);
                return null;
            });
    },
    deleteFile(id) {
        return apiClient.delete(`/savedFiles/${id}`)
            .then(response => {
                console.log(response.data);
                return response.data;
            })
            .catch(error => {
                console.log(error);
                return null;
            });
    },


    getChapters(tags = undefined) {
        return apiClient.get( "/chapters" + (tags ? "?tags=" + tags  : "")).then(result => {
            //console.log("Chapters:", result.data)
            return result.data.results
        })
    },
    deleteChapter(chapter) {
        return apiClient.delete(`/chapters/${chapter.id}`)
    },
    saveChapter(chapter) {
        if(!chapter.id) {
            return apiClient.post("/chapters", chapter).then(result => {
                return result.data
            })
        } else {
            const _chapter = { ...chapter }
            const chapterId = chapter.id
            delete _chapter.id
            delete _chapter.createdAt
            delete _chapter.updatedAt
            return apiClient.patch(`/chapters/${chapterId}`, _chapter).then(result => {
                return result.data
            })
        }
    },
    getChapter(chapter) {
        return apiClient.get(`/chapters/${chapter.id}`).then(result => {
            return result.data
        })
    },
    isChapterTitleTaken(chapterTitle) {
        return apiClient.get(`/chapters?name=${chapterTitle}`).then((result) => {
            return result.data.totalResults > 0
        })
    },
    getFiles() {
        return apiClient.get("/files");
    },
    getLessons(tags = undefined) {
        return apiClient.get( "/lessons" + (tags ? "?tags=" + tags  : "")).then(result => {
            return result.data.results
        })
    },
    //Favorites
    async createFavorite(favorite) {
        console.log(favorite);
        return apiClient.post("/favorites", favorite).then(result => {
            console.log(result);
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async updateFavorite(favorite) {
        let _fav = JSON.parse(JSON.stringify(favorite));
        delete _fav.id;
        console.log(_fav);
        return apiClient.patch("/favorites/"+favorite.id, _fav).then(result => {
            console.log(result);
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async deleteFavorite(favorite_id){
        console.log("delete "+favorite_id);
        return apiClient.delete("/favorites/"+favorite_id).then(result => {
            console.log(result);
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async getFavorites(list) {
        console.log(list);
        return apiClient.get('/favorites?list='+list).then(result => {
            return result.data.results
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async getFavoritesForUser(user) {
        console.log(user);
        return apiClient.get('/favorites?user='+user).then(result => {
            return result.data.results
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async createFavoritesLists(list) {
        return apiClient.post("/favoriteslists", list).then(result => {
            console.log(result);
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async updateFavoritesLists(list) {
        let _list = {...list};
        delete _list.id;
        return apiClient.patch("/favoriteslists/"+list.id, _list).then(result => {
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async deleteFavoritesList(list_id){
        return apiClient.delete("/favoriteslists/"+list_id).then(result => {
            console.log(result);
            return result.data
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async getFavoritesLists(user) {
        console.log(user);
        return apiClient.get('/favoriteslists').then(async result => {
            console.log(result.data.results);
            if(result.data.results.length == 0){
                console.log("create favorite list all");
                let list = {};
                list.title = "favorites";
                list.user = user;
                let lists = [];
                lists.push( await this.createFavoritesLists(list));
                return lists;
            }
            return result.data.results;
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async getFavoritesListsUser(user) {
        return apiClient.get('/favoriteslists').then(async result => {
            let favs = [];
            for(let i=0; i < result.data.results.length; i++){
                if(result.data.results[i].user != user){
                    continue;
                }
                if(!result.data.results[i].group || result.data.results[i].group == ""){
                    favs.push(result.data.results[i]);
                }
            }
            if(favs.length == 0){
                console.log("create favorite list all");
                let list = {};
                list.title = "favorites";
                list.user = user;
                let lists = [];
                lists.push( await this.createFavoritesLists(list));
                return lists;
            }

            return favs;
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
    async getFavoritesListsGroup(group) {
        console.log(group);
        return apiClient.get('/favoriteslists?group='+group).then(result => {
            console.log(result.data);
            return result.data.results
        }).catch(error => {
            console.log(error);
            return null;
        });
    },
}
